import { AsyncPipe } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { ToastService } from '../toast-container/toast.service';

@Component({
  selector: 'app-progress-dialog',
  templateUrl: 'progress-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AsyncPipe, TranslateModule],
})
export class ProgressDialogComponent {
  private toastService = inject(ToastService);
  private translateService = inject(TranslateService);

  public title = '';
  public password = '';
  public progressSubject: BehaviorSubject<ProgressData>;

  protected copyToClipboard(password) {
    navigator.clipboard.writeText(password).then(
      () => {
        this.toastService.success(
          this.translateService.instant('toastr.copiedToClipboardMessage'),
          this.translateService.instant('toastr.copiedToClipboardTitle')
        );
      },
      (err) => {
        this.toastService.danger(
          this.translateService.instant('shared.clipboard.copyFailed')
        );
      }
    );
  }
}

export interface ProgressData {
  status: string;
  value: number;
  success?: boolean;
}
